import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

export const ScheduleSuggestionsSkeleton: React.FC = () => {
  return (
    <div className="w-full -mt-2 space-y-2 animate-pulse">
      {/* SEÇÃO 1 e 2 lado a lado */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-stretch">
        <Card
          variant="default"
          className="h-full p-5 sm:p-6 rounded-2xl border-purple-200 bg-white"
        >
          <div className="flex items-center gap-3 mb-4">
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              className="rounded-xl"
            />
            <div className="space-y-2">
              <Skeleton variant="text" width="150px" height="1.1rem" />
              <Skeleton variant="text" width="190px" height="0.75rem" />
            </div>
          </div>

          <div className="mb-5 space-y-2.5">
            <Skeleton variant="text" width="120px" height="0.75rem" />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  width="100%"
                  height={38}
                  className="rounded-xl"
                />
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="space-y-2">
                <Skeleton variant="text" width="100px" height="0.75rem" />
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={40}
                  className="rounded-xl"
                />
              </div>
            ))}
          </div>

          <div className="mt-5 pt-4 border-t border-gray-100 flex flex-wrap gap-6">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="text"
                width={i === 4 ? "140px" : "70px"}
                height="0.875rem"
              />
            ))}
          </div>
        </Card>

        <Card
          variant="default"
          className="h-full p-5 sm:p-6 rounded-2xl border-purple-200 bg-white"
        >
          <div className="flex items-center gap-3 mb-5">
            <Skeleton
              variant="rectangular"
              width={40}
              height={40}
              className="rounded-xl"
            />
            <div className="space-y-2">
              <Skeleton variant="text" width="160px" height="1.1rem" />
              <Skeleton variant="text" width="200px" height="0.75rem" />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={62}
              className="rounded-xl"
            />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={62}
              className="rounded-xl"
            />
          </div>
          <div className="pt-5 border-t border-gray-100 space-y-1.5">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width="100%"
                height={38}
                className="rounded-lg"
              />
            ))}
          </div>
        </Card>
      </div>

      {/* SEÇÃO 3: PERSONALIZAÇÃO DO MOTOR IA (expandida por padrão) */}
      <Card
        variant="default"
        className="p-5 sm:p-6 rounded-2xl border-purple-200 bg-white"
      >
        <div className="flex items-center gap-3 mb-6">
          <Skeleton
            variant="rectangular"
            width={40}
            height={40}
            className="rounded-xl"
          />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width="220px" height="1.1rem" />
            <Skeleton variant="text" width="180px" height="0.75rem" />
          </div>
          <Skeleton
            variant="rectangular"
            width={20}
            height={20}
            className="rounded-sm"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-2">
              <Skeleton variant="text" width="100px" height="0.75rem" />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={40}
                className="rounded-xl"
              />
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="space-y-2">
              <Skeleton variant="text" width="120px" height="0.75rem" />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={64}
                className="rounded-xl"
              />
            </div>
          ))}
        </div>
      </Card>

      {/* Ação Final */}
      <div className="p-4 sm:p-5 rounded-2xl border border-purple-100 bg-purple-50/40 flex items-center justify-between gap-4">
        <div className="space-y-2">
          <Skeleton variant="text" width="220px" height="1rem" />
          <Skeleton variant="text" width="280px" height="0.75rem" />
        </div>
        <Skeleton
          variant="rectangular"
          width={180}
          height={44}
          className="rounded-xl shrink-0"
        />
      </div>
    </div>
  );
};

export default ScheduleSuggestionsSkeleton;
